import { SET_HOOK_CACHE_VALUES } from "@lululemon/ecom-pdp/src/store/actions/pdp-actions";

const pdpHooksCache = (state = {}, action) => {
  if (action.type === SET_HOOK_CACHE_VALUES) {
    const cacheValues = action.payload;
    return {
      ...state,
      ...cacheValues,
    };
  } else {
    return state;
  }
};

export default pdpHooksCache;
